import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import { SmallGmailSvgIcon, SmallOutlookSvgIcon } from "../CommonSvgs";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ToastContainer, toast } from "react-toastify";
import { useFormik } from "formik";
import { useLocation } from "react-router-dom";
import {
  spfDomainSchema,
  verifySingleMailSchema,
} from "../Schemas/ChangePassword";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { StepLabel } from "@mui/material";

const esttoolsData = [
  {
    id: 1,
    svg: <SmallGmailSvgIcon />,
    text: "Gmail",
  },
  {
    id: 2,
    svg: <SmallOutlookSvgIcon />,
    text: "Outlook",
  },
];


const SpfGenerator = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [activeStep, setActiveStep] = useState(0);
  const pathLocation = useLocation();
  const [completed, setCompleted] = useState({});
  const [copyIcon, setCopyIcon] = useState(false);
  const [catchDomainName, setCatchDomainName] = useState("");
  const [catchSPFValue, setCatchSPFValue] = useState("");
  const [catchDMARCValue, setCatchDMARCValue] = useState("");
  const path = pathLocation.pathname === "/Accounts/dmarc-generator";
  const steps = ["Domain", "Email", `${path ? "DMARC value":"SPF value"}`];

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all stepsData have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleEmailNextStep = (values, actions) => {
    const apiString =
      pathLocation.pathname === "/Accounts/dmarc-generator"
        ? "get-dmarc-record"
        : "get-spf-record";
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/user-from-email/${apiString}/${
          userDetails && userDetails.details._id
        }`,
        {
          email: values.email,
        },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.status) {
          pathLocation.pathname === "/Accounts/dmarc-generator"
            ? setCatchDMARCValue(response.data.details)
            : setCatchSPFValue(response.data.details);
          handleNext();
        }
      })
      .catch((error) => {
        console.log(error.message);
        toast.error(error.message);
      });
  };

  const handleDomainNextStep = (values, actions) => {
    setCatchDomainName(values.domain);
    handleNext();
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    handleReset,
    isValid,
  } = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: verifySingleMailSchema,
    onSubmit: handleEmailNextStep,
  });

  const domainFormik = useFormik({
    initialValues: {
      domain: "",
    },
    validationSchema: spfDomainSchema,
    onSubmit: handleDomainNextStep,
  });

  useEffect(() => {
    setActiveStep(0);
    if (isValid) {
      handleReset();
    }
    if (domainFormik.isValid) {
      domainFormik.handleReset();
    }
  }, [path]);

  const totalSteps = () => {
    return steps.length + 1;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  const divRef = useRef([]);

  const copyText = () => {
    setCopyIcon(true);
    // Ensure that the div reference is not null
    if (divRef.current) {
      // Create a range and select the text content of the div
      const range = document.createRange();
      range.selectNode(divRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      // Execute the copy command
      document.execCommand("copy");

      // Clear the selection
      window.getSelection().removeAllRanges();

      // You can also provide user feedback here, like a message or notification
      console.log("Text copied to clipboard");
      setTimeout(() => {
        setCopyIcon(false);
      }, 1500);
    }
  };

  const domainStepUi = () => {
    return (
      <div
        style={{
          display: "flex",
          flexdirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "350px",
          padding: "0px 24px",
        }}
      >
        <div
          style={{
            padding: "0px 6px",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 20,
          }}
        >
          {path && (
            <p
              style={{
                alignSelf: "center",
                fontFamily: "Source Sans 3",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#1C485F",
              }}
            >
              Let's get started!
            </p>
          )}
          <p
            style={{
              alignSelf: "center",
              fontFamily: "Source Sans 3",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 400,
              color: "#1C485F",
              marginTop: 0,
            }}
          >
            {path
              ? "Please provide the domain for which you'd like to generate a DMARC record"
              : "Let's secure your domain! Enter the domain to set up SPF records"}
          </p>
          <form
            onSubmit={domainFormik.handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <div>
              <input
                type="text"
                id="domain"
                name="domain"
                value={domainFormik.values.domain}
                onChange={domainFormik.handleChange}
                onBlur={domainFormik.handleBlur}
                style={{
                  padding: "13px 6px",
                  borderRadius: 5,
                  width: "100%",
                  border: "2px solid #DDD",
                  outline: "none",
                  fontSize: "24px",
                  color: "#868686",
                }}
                placeholder="Enter the domain..."
              />
              {domainFormik.errors.domain && domainFormik.touched.domain && (
                <p className="text-red-600">
                  Please enter a valid domain name (ex:coldsender.com)
                </p>
              )}
            </div>
            <button
              type="submit"
              className="bg-primary"
              style={{
                alignSelf: "center",
                padding: "6px 44px",
                borderRadius: 6,
                outline: "none",
                color: "#FFF",
                fontSize: "24px",
              }}
            >
              Next
            </button>
          </form>
        </div>
      </div>
    );
  };

  const espStepUi = () => {
    return (
      <div
        style={{
          // please uncomment this lines of code when you have multiple esp tools array data
          //   display: "flex",
          //   flexdirection: "column",
          //   justifyContent: "center",
          //   alignItems: "center",
          minHeight: "350px",
          padding: "12px 24px",
        }}
      >
        <div
          style={{
            padding: "0px 6px",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 20,
          }}
        >
          <p
            style={{
              alignSelf: "center",
              fontFamily: "Source Sans 3",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 400,
              color: "#1C485F",
            }}
          >
            Choose your ESP or email outreach tools
          </p>
          <div className="grid grid-cols-4 gap-4">
            {esttoolsData.map((tool) => (
              <div
                key={tool.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  border: "1px solid #DDD",
                  padding: "10px 14px",
                  borderRadius: 5,
                }}
              >
                {tool.svg}
                <p
                  style={{
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    color: "#868686",
                  }}
                >
                  {tool.text}
                </p>
              </div>
            ))}
          </div>
          <button
            className="bg-primary"
            style={{
              alignSelf: "center",
              padding: "6px 44px",
              borderRadius: 6,
              outline: "none",
              color: "#FFF",
              fontSize: "24px",
            }}
          >
            Next
          </button>
        </div>
      </div>
    );
  };

  const emailStepUi = () => {
    return (
      <div
        style={{
          display: "flex",
          flexdirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "350px",
          padding: "0px 24px",
        }}
      >
        <div
          style={{
            padding: "0px 6px",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 20,
          }}
        >
          <p
            style={{
              alignSelf: "center",
              fontFamily: "Source Sans 3",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 400,
              color: "#1C485F",
            }}
          >
            {pathLocation.pathname === "/Accounts/dmarc-generator"
              ? "Specify the email address below to receive your newly generated DMARC record"
              : "Enter your email address below to receive the newly created SPF record at your chosen location"}
          </p>
          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <div>
              <input
                type="text"
                id="email"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                style={{
                  padding: "13px 6px",
                  borderRadius: 5,
                  width: "100%",
                  border: "2px solid #DDD",
                  outline: "none",
                  fontSize: "24px",
                  color: "#868686",
                }}
                placeholder="Enter your email address..."
              />
              {errors.email && touched.email && (
                <p className="text-red-600">
                  Please enter a valid email address
                </p>
              )}
            </div>
            <button
              type="submit"
              className="bg-primary"
              style={{
                alignSelf: "center",
                padding: "6px 44px",
                borderRadius: 6,
                outline: "none",
                color: "#FFF",
                fontSize: "24px",
              }}
            >
              Next
            </button>
          </form>
        </div>
      </div>
    );
  };

  const spfValueStepUi = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minHeight: "350px",
          padding: "0px 24px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          <p
            style={{
              alignSelf: "center",
              fontFamily: "Source Sans 3",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 400,
              color: "#1C485F",
            }}
          >
            {path ? "Suggested DMARC Records" : "Suggested SPF Records"}
          </p>
          <div
            ref={divRef}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#EBF1FE",
              borderRadius: 5,
              padding: "14px 10px",
            }}
          >
            <input
              type="text"
              readOnly={true}
              value={path ? catchDMARCValue : catchSPFValue}
              style={{
                outline: "none",
                backgroundColor: "transparent",
                flexGrow: 1,
              }}
            />
            <button onClick={copyText}>
              {copyIcon ? (
                <CheckCircleIcon color="blue" />
              ) : (
                <ContentCopyIcon />
              )}
            </button>
          </div>
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: 6,
            }}
          >
            <p
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "13px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#868686",
              }}
            >
              Unlock a 7-day free trial and explore all of Warmy’s features
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
              }}
            >
              <button
                style={{
                  backgroundColor: "#FF3301",
                  padding: "12px 14px",
                  borderRadius: 6,
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#FFF",
                }}
              >
                Book a demo
              </button>
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "1px solid #FF3301",
                  padding: "12px 14px",
                  borderRadius: 6,
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#FF3301",
                }}
              >
                Get 7-Days Trail
              </button>
            </div>
          </div> */}
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
        backgroundColor: "#FFF",
        borderRadius: "5px",
      }}
    >
      <div
        className="container"
        style={{
          margin: "auto",
          backgroundColor: "#FFF",
          borderRadius: 5,
          padding: "10px 20px",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            borderRadius: 5,
            boxShadow:
              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
            width: "80%",
            overflow: "hidden",
            margin: "auto",
          }}
        >
          <Box
            sx={{
              padding: "8px 6px",
              borderBottom: "1px solid #DDD",
              backgroundColor: "#FAFAFB",
            }}
          >
            <Stepper
              activeStep={activeStep}
              sx={{
                padding: "12px 0px",
              }}
            >
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={index} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Box>
          {activeStep === 0
            ? domainStepUi()
            : activeStep === 1
            ? emailStepUi()
            : spfValueStepUi()}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default SpfGenerator;
